import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const ProductCard = ({ product, index = 0 }) => {
  const dark = product.color === "White";
  const comingSoon = product.status === "coming_soon";
  const stock = product.stock || {};
  const totalStock = Object.values(stock).reduce((a, b) => a + b, 0);
  const soldOut = !comingSoon && totalStock <= 0;
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/shop/${product.lookup_key}`}
        data-testid={`product-card-${product.lookup_key}`}
        className={`group block transition-colors duration-500 ${
          dark ? "bg-[#050505] text-white" : "bg-white text-black"
        }`}
      >
        <div className="relative overflow-hidden aspect-[4/5]">
          <div className="w-full h-full transition-transform duration-700 ease-out group-hover:scale-[1.04]">
            <img
              src={product.image}
              alt={product.name}
              loading="lazy"
              className="w-full h-full object-cover transition-opacity duration-500 group-hover:opacity-0"
            />
            <img
              src={product.image_back}
              alt={`${product.name} — back`}
              loading="lazy"
              data-testid={`product-card-back-${product.lookup_key}`}
              className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100"
            />
          </div>
          <span
            className={`absolute top-4 left-4 text-[9px] tracking-[0.3em] uppercase px-3 py-1.5 ${
              dark ? "bg-white text-black" : "bg-black text-white"
            }`}
          >
            {product.tag}
          </span>
          {(soldOut || comingSoon) && (
            <span
              data-testid={`product-card-soldout-${product.lookup_key}`}
              className={`absolute inset-0 flex items-center justify-center ${
                dark ? "bg-black/40" : "bg-white/40"
              }`}
            >
              <span className={`border px-6 py-2.5 text-[10px] tracking-[0.4em] uppercase font-semibold ${
                dark ? "border-white text-white bg-black/70" : "border-black text-black bg-white/80"
              }`}>
                {comingSoon ? "Coming Soon" : "Sold Out"}
              </span>
            </span>
          )}
        </div>
        <div className="flex items-start justify-between p-5">
          <div>
            <p className="text-[11px] tracking-[0.2em] uppercase font-semibold">{product.name}</p>
            <p className={`text-[10px] tracking-[0.2em] uppercase mt-1 ${dark ? "text-white/40" : "text-black/40"}`}>
              {product.category === "hoodie"
                ? `${product.color} — Drop 002`
                : `${product.color} — Front & Back Print`}
            </p>
            {!soldOut && totalStock < 10 && (
              <p
                data-testid={`product-card-low-${product.lookup_key}`}
                className="text-[9px] tracking-[0.3em] uppercase font-semibold mt-2"
              >
                Only {totalStock} left
              </p>
            )}
          </div>
          {comingSoon ? (
            <p className={`text-[10px] tracking-[0.3em] uppercase font-semibold ${dark ? "text-white/70" : "text-black/70"}`}>
              ${product.price.toFixed(0)} — Drop 002
            </p>
          ) : product.sale_percent ? (
            <p className="text-sm font-medium" data-testid={`sale-price-${product.lookup_key}`}>
              <span className={`line-through mr-2 ${dark ? "text-white/35" : "text-black/35"}`}>
                ${product.price.toFixed(2)}
              </span>
              ${(product.price * (1 - product.sale_percent / 100)).toFixed(2)}
            </p>
          ) : (
            <p className="text-sm font-medium">${product.price.toFixed(2)}</p>
          )}
        </div>
      </Link>
    </motion.div>
  );
};
